import { apiService } from '../../shared/services/apiService';
import { ScanIqCurrentSubscriptionInfo } from '../interfaces/customerSubscription';
import { SpringPagination } from '../../shared/interfaces/SpringPagination';
import {
  ScanIqPaymentHistoryFilters,
  ScanIqPaymentHistoryRecord,
} from '../interfaces/scanIqPaymentHistoryList';
import { getFilteredTruthyFieldsObj } from '../../shared/utils/sortingAndGroupingUtil';

type GetPaymentHistoryResponse = SpringPagination<ScanIqPaymentHistoryRecord[]>;

type CancelSubscriptionResponse = {
  success: true;
  effectedTransaction: number;
};

export const scanIqCustomerPaymentService = {
  async getCurrentSubscriptionInfo(entityId: number, customerId: number) {
    const response = await apiService.get<ScanIqCurrentSubscriptionInfo>(
      `/api/entity/${entityId}/scan-iq/customer/${customerId}/subscriptions/current`,
    );

    return response.data;
  },

  async cancelSubscription(
    entityId: number,
    customerId: number,
    subscriptionTransactionId: number,
  ) {
    const response = await apiService.put<CancelSubscriptionResponse>(
      `/api/entity/${entityId}/scan-iq/customer/${customerId}/subscriptions/${subscriptionTransactionId}/cancel`,
    );

    return response.data;
  },

  async getPaymentHistory(
    entityId: number,
    customerId: number,
    params: ScanIqPaymentHistoryFilters,
  ) {
    const filteredParams = getFilteredTruthyFieldsObj(params);

    const response = await apiService.post<GetPaymentHistoryResponse>(
      `/api/entity/${entityId}/scan-iq/customer/${customerId}/payment-history`,
      filteredParams,
    );

    return response.data;
  },
};
